import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Card } from "primereact/card";
import { Chip } from "primereact/chip";
import { Badge } from "primereact/badge";
import { Timeline } from "primereact/timeline";
 
 
 
 
 
export default function MaisNegocio({
  maisNegocio
}: {
  maisNegocio: any
}) {
  const { t } = useTranslation();
 
 
 
const headerCard= (item:any) => {
  return <div className="flex-score align-items-center" style={{padding: '1.5rem'}}><div className="flex-score justify-content-center align-items-center p-2 border-round" style={{backgroundColor: '#005580'}}><i className="pi pi-info" style={{color: "#FFF"}}></i></div><span className="text-xl ml-2 font-semibold">{item}</span></div>
} 
 
const customizedMarker = (item:any) => {
  return (
      <span className="flex-score w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" style={{ backgroundColor: 'rgb(96, 125, 139)' }}>
          
          <Badge style={{backgroundColor: 'rgb(96, 125, 139)', color:'white'}} value={maisNegocio.motivos.indexOf(item) + 1}></Badge>
      </span>
  );
};
 
const customizedContent = (item:any) => {
  return (
    <div>
    <Card className="mais-negocio-motivo-card flex-score flex-column" header={headerCard(item)} style={{color: '#005580', borderLeft: '4px solid', background:'rgb(248,248,255)'}}>
    </Card>
    <br></br>
  </div>
  );
};
   
 
    
  
  return (
    <div>
      
      <Panel header={t('maisNegocio')}>
        <Card className="card-proposta-credito" style={{ height: '10rem'}}>
          <div className="grid" style={{paddingTop: '1rem'}}>
              <div className="col p-fluid flex flex-wrap">
                  <h2>{maisNegocio.razaoSocial}</h2>
              </div>
                <div style={{alignContent:"end", marginTop: '-1rem', padding: '0.5rem'}}>
                  <div className="row-proposta-credito">
                      <div className="column-proposta-credito">
                        <span style={{fontWeight: '500'}}><b>Documento:</b> <Badge className="status-badge-main" value={maisNegocio.cnpj}></Badge></span>
                      </div>
                  </div>
                  <div className="row-proposta-credito" style={{paddingTop: '0.3rem'}}>
                      <div className="column-proposta-credito">
                          <span style={{fontWeight: '500'}}><b>Risco Perfil analisado:</b> </span><Badge className="status-badge-main" value={maisNegocio.risco}></Badge>
                      </div>
                  </div>
                  <div className="row-proposta-credito" style={{paddingTop: '0.3rem'}} >
                      <div className="column-proposta-credito">
                          <span style={{fontWeight: '500'}}><b>Capacidade de pagamento:</b> </span><Badge className="status-badge-main" value={maisNegocio.capacidadePagamento}></Badge>
                      </div>
                  </div>
                  <div className="row-proposta-credito" style={{paddingTop: '0.3rem'}} >
                      <div className="column-proposta-credito">
                          <span style={{fontWeight: '500'}}><b>Porte da empresa:</b> </span><Badge className="status-badge-main" value={maisNegocio.porte}></Badge>
                      </div>
                  </div>
                </div>
            </div>
        </Card>
        <br></br>
       
        <br></br>
        <div className="grid">
          <div className="col">
            <div className="grid">
              <div style={{textAlign: 'center'}} className="col p-fluid flex flex-wrap">
                <h2><p style={{color: maisNegocio.recomendacao === '1 - NÃO RECOMENDADA' ? '#cc0000': ( maisNegocio.recomendacao === '0 - RECOMENDADA' ? '#008000' : '#eec137' )}}>{maisNegocio.recomendacao.replace('1 - ', '').replace('0 - ', '').replace('2 - ', '')}</p></h2>
                <div style={{width: '100%', paddingLeft: '37%'}}>
                  <div className="semaforo">
                    <div id="farolVermelho" className={(maisNegocio.recomendacao === '1 - NÃO RECOMENDADA' ? 'cor-vermelha pi pi-times-circle': '') + ' luz'}></div>
                    <div id="farolAmarelo" className={(maisNegocio.recomendacao === '2 - RECOMENDA-SE ANÁLISES ADICIONAIS' ? 'cor-amarela pi pi-exclamation-triangle': '') + ' luz'}></div>
                    <div id="farolVerde" className={(maisNegocio.recomendacao === '0 - RECOMENDADA' ? 'cor-verde pi pi-verified': '') + ' luz'}></div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <div className="col">
            <div style={{width: '100%'}}>
              <Timeline value={maisNegocio.motivos} align="left" className="time-mais-negocio w-full md:w-20rem" marker={customizedMarker} content={customizedContent} />
            </div>
          </div>
        </div>
        
        <br></br>
        
      </Panel>
   
    
    
    </div>
  )
}